import React from 'react';
import { useHits } from 'react-instantsearch-hooks-web';
import { TcDirectoryHit } from './TcDirectoryHit';

type CustomHitsProps = {
  txId: string;
};
const TcHits = ({ txId }: CustomHitsProps) => {
  const { hits } = useHits();

  return (
    <>
      {hits.map((hit) => (
        <TcDirectoryHit txId={txId} hit={hit} key={hit.objectID} />
      ))}
    </>
  );
};
export default TcHits;
